import React from 'react';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

const MobileHorizontalScrollerBox = ({ children, isMobile, sx, ...props }) => (
  <Box
    sx={{
      display: 'flex',
      gap: 2,
      height: '100%',
      overflowX: isMobile ? 'auto' : undefined,
      '&::-webkit-scrollbar': {
        display: 'none',
      },
      '&::-webkit-scrollbar-track': {
        display: 'none',
      },
      '&::-webkit-scrollbar-thumb': {
        display: 'none',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        display: 'none',
      },
      ...sx,
    }}
    {...props}
  >
    {children}
  </Box>
);

MobileHorizontalScrollerBox.propTypes = {
  children: PropTypes.node,
  isMobile: PropTypes.bool,
  sx: PropTypes.shape({}),
};

MobileHorizontalScrollerBox.defaultProps = {
  children: null,
  isMobile: false,
  sx: {},
};

export default MobileHorizontalScrollerBox;
